import React, { useEffect, useState } from "react";
import s from "./style.module.scss";
import GoBack from "shared/ui/GoBack";
import { AuthContentProps } from "./types";
import Bonuses from "shared/ui/Bonuses";
import Button from "shared/ui/Button";
import Coins from "shared/ui/Bonuses/icons/Coins";
import ImageLazy from "shared/ui/ImageLazy";
import { useAppDispatch, useAppSelector } from "shared/redux/hooks";
import { userSelect } from "shared/redux/selectors/user";
import { setContent, setOpen } from "shared/redux/reducers/PopupSlice";
import BuyConfirm from "./BuyConfirm";
import { fetchUserInfo } from "shared/redux/asyncActions/fetchUserInfo";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { GetTransactionBonusesApi } from "./api";
import Activate from "./Activate";

const AuthContent: React.FC<AuthContentProps> = ({
  gift,
  fetchGiftInfo,
  news,
}) => {
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const { user_info, auth_key } = useAppSelector(userSelect);

  const [payed, setPayed] = useState(false);
  const [userBonuses, setUserBonuses] = useState([]);

  const needToGet = Number(gift?.price) - Number(user_info?.balance);

  const callbackSuccessAction = (tr_id: number, active: boolean) => {
    if (user_info && auth_key) {
      dispatch(fetchUserInfo({ auth_key, user_id: user_info.id }));
      fetchGiftInfo();
      dispatch(setOpen(false));

      if (pathname === `/gift/${id}` && active) {
        navigate(`/account/gift/${tr_id}`);
      }
    }
  };

  const handlePay = () => {
    if (gift) {
      dispatch(setOpen(true));
      dispatch(
        setContent(
          <BuyConfirm
            malls={gift.malls}
            text={gift.mes_to_act}
            id={Number(id)}
            onSuccess={callbackSuccessAction}
            price={gift.price}
          />
        )
      );
    }
  };

  const handleActivate = () => {
    if (gift) {
      dispatch(setOpen(true));
      dispatch(
        setContent(
          <Activate
            id={Number(id)}
            text={gift.mes_to_act}
            onSuccess={callbackSuccessAction}
            price={gift.price}
          />
        )
      );
    }
  };

  useEffect(() => {
    if (userBonuses.length > 0) {
      userBonuses.forEach((bonus: any) => {
        if (bonus.bonus_id === Number(id)) {
          setPayed(true);
        }
      });
    }
  }, [userBonuses]);

  useEffect(() => {
    if (user_info && gift) {
      GetTransactionBonusesApi({
        user_id: user_info.id ? user_info.id : null,
        auth_key,
      }).then((res) => {
        setUserBonuses(res);
      });
    }
  }, [user_info, gift]);

  return (
    <section className={s.content}>
      <section className={s.content}>
        <div className={s.top}>
          <GoBack className={s.go_back} />

          <div className={s.image}>
            {gift && <ImageLazy src={gift.image} alt="Gift" />}
          </div>

          <div className={s.data}>
            <h1>{gift?.title}</h1>

            <div className={s.row}>
              <div className={s.group}>
                {gift?.place_title && (
                  <span className={s.shop}>{gift?.place_title}</span>
                )}

                {gift?.period_to && (
                  <span className={s.date}>
                    {new Date(gift.period_to).toLocaleDateString()}
                  </span>
                )}
              </div>

              {gift && gift?.price > 0 && <Bonuses count={gift.price} />}
            </div>
          </div>
        </div>

        <div className={s.block}>
          {gift && gift?.malls.length > 0 && (
            <ul className={s.malls}>
              {gift.malls.map((item) => (
                <li key={item.id} className={s.item}>
                  {item.title}
                </li>
              ))}
            </ul>
          )}

          {!gift ? (
            <div className={s.data}></div>
          ) : (
            <div
              className={s.data}
              dangerouslySetInnerHTML={{ __html: gift?.text }}
            ></div>
          )}

          {!news && (
            <div className={s.payment}>
              {payed ? (
                <Button onClick={handleActivate}>Активировать</Button>
              ) : (
                <Button className={s.button} onClick={handlePay}>
                  Оплатить
                  <b>
                    <Coins />

                    {gift?.price}
                  </b>
                </Button>
              )}

              {needToGet > 0 && <p>Вам осталось накопить {needToGet} баллов</p>}
            </div>
          )}
        </div>
      </section>
    </section>
  );
};

export default AuthContent;
